import React from 'react';

const Context = React.createContext({ statusMessage : []});

export default Context;
